<app-breadcrumb></app-breadcrumb>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <h5>
                    <i class="far fa-file-alt fa-fw"></i>
                    운행 정보
                </h5>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-success"
                    (click)="excelDownload()">
                    <i class="fas fa-file-excel"></i>
                    <span class="ml-1">엑셀출력</span>
                </button>
            </div>
        </div>

        <div class="table-responsive mt-3">
            <table class="table table-sm table-hover align-items-center mb-0 text-nowrap">
                <thead>
                    <tr class="text-center">
                        <th>
                            No
                        </th>
                        <th>
                            시작
                        </th>
                        <th>
                            종료
                        </th>
                        <th>
                            운행시간
                        </th>
                        <th>
                            운행거리(km)
                        </th>
                        <th>
                            당시운전자
                        </th>
                        <th>
                            연료소모량(L)
                        </th>
                        <th>
                            종료온도1(°C)
                        </th>
                        <th>
                            종료온도2(°C)
                        </th>
                        <th>
                            위치(종료)
                        </th>
                        <th>
                            트립상세운행일지
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="!listItem || listItem.length < 1">
                        <tr class="text-center">
                            <td colspan="10">
                                표시 할 항목이 없습니다
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngFor="let item of listItem;let idx = index;">
                        <tr>
                            <td class="text-center">
                                {{pagingInfo.listCnt - ((pagingInfo.curPage-1)*pagingInfo.pageSize) - idx }}
                            </td>
                            <td class="text-center">
                                {{item.dtgRegDtFrom}}
                            </td>
                            <td class="text-center">
                                {{item.dtgRegDtTo}}
                            </td>
                            <td class="text-center">
                                {{item.dtgRegDtDuration | filterSecToTime}}
                            </td>
                            <td class="text-center">
                                {{(item.dtgDistAccumulTo - item.dtgDistAccumulFrom) | filterDist | number:'0.0-3'}}
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-link text-cyan"
                                    [routerLink]="['/','dtg','report','user','personal',item.userId]">
                                    {{item.userNm || '미지정'}}<br>
                                    ({{item.userId}})
                                </button>
                            </td>
                            <td class="text-center">
                                {{(item.dtgOilUseAccumulTo - item.dtgOilUseAccumulFrom) | filterDist | number:'0.0-2'}}
                            </td>
                            <td class="text-center">
                                {{(item.dtgTemper1 * 0.1) | number:'0.0-1'}}
                            </td>
                            <td class="text-center">
                                {{(item.dtgTemper2 * 0.1) | number:'0.0-1'}}
                            </td>
                            <td class="text-left">
                                {{item.dtgGpsAddr || '-'}}
                            </td>
                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-link text-cyan"
                                    [routerLink]="['/','dtg','report','car','detail',item.dtgUnitId,item.fvmsTripCnt]">
                                    <i class="far fa-file-alt"></i>
                                    확인
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="mt-3">
            <list-paging
                [inputPagingInfo]="pagingInfo"
                (callbackClickPageNumber)="callbackClickPageNumber($event)"
                (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
        </div>
    </div>
</div>

<div class="card mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col">
                <h5>
                    <i class="far fa-file-alt fa-fw"></i>
                    운행시간
                </h5>
                <div id="chart-01" style="height: 150px;"></div>
                <table class="table table-sm table-bordered align-items-center mb-0 mt-2" [hidden]="!listChart">
                    <thead>
                        <tr class="text-center">
                            <th>
                                총운행시간
                            </th>
                            <th>
                                일평균운행시간
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center">
                            <td>
                                {{listSummary.dtgRegDtDurationSum | filterSecToTime}}
                            </td>
                            <td>
                                {{listSummary.dtgRegDtDurationAvg | filterSecToTime}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col">
                <h5>
                    <i class="far fa-file-alt fa-fw"></i>
                    공회전시간
                </h5>
                <div id="chart-02" style="height: 150px;"></div>
                <table class="table table-sm table-bordered align-items-center mb-0 mt-2" [hidden]="!listChart">
                    <thead>
                        <tr class="text-center">
                            <th>
                                총공회전시간
                            </th>
                            <th>
                                일평균공회전시간
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center">
                            <td>
                                {{listSummary.dtgIdleSecSum | filterSecToTime}}
                            </td>
                            <td>
                                {{listSummary.dtgIdleSecAvg | filterSecToTime}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col">
                <h5>
                    <i class="far fa-file-alt fa-fw"></i>
                    운행거리
                </h5>
                <div id="chart-03" style="height: 150px;"></div>
                <table class="table table-sm table-bordered align-items-center mb-0 mt-2" [hidden]="!listChart">
                    <thead>
                        <tr class="text-center">
                            <th>
                                총운행거리
                            </th>
                            <th>
                                일평균운행거리
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center">
                            <td>
                                {{listSummary.dtgDistAccumulSum | filterDist | number:'0.0-3'}} km
                            </td>
                            <td>
                                {{listSummary.dtgDistAccumulAvg | filterDist | number:'0.0-3'}} km
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>